import ProgressiveImage from 'src/common/components/ProgressiveImage';

interface Props {
  src: string;
  backgroundPosition?: string;
  priority?: boolean;
  top?: number | string;
  height?: string;
}

export default function ProgressiveBackground({
  src,
  backgroundPosition = 'center center',
  priority = true,
  top = 0,
  height = '100%',
}: Props) {
  return (
    <ProgressiveImage
      src={src}
      alt=""
      priority={priority}
      fill
      objectFit="cover"
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        top,
        height,
        zIndex: 0,
        '& img': {
          objectPosition: backgroundPosition,
        },
      }}
      data-testid="hero-progressive-background"
    />
  );
}
